import { jsxs as _jsxs } from "react/jsx-runtime";
import { LONG_TOUR_HOMES } from './_estimate';
const LongTourNote = (props) => {
    return props.homes.length > LONG_TOUR_HOMES ? (_jsxs("p", { className: "small text-danger mt-2 mb-0", children: ["Over ", LONG_TOUR_HOMES, " stops runs long for one outing. Consider splitting it into two routes."] })) : null;
};
export default LongTourNote;
